angular.module('bb.network', ['ngRoute', 'ngMap']);

require('./network_map');

require('../view/listing_view.service');

require('./network.routes');
